import React, { useState, useEffect, useRef } from 'react';
import './career.css';
import axios from "axios";
import { CiEdit } from 'react-icons/ci';

// const BASE_URL   = "https://staging.pteshstudios.com";
const BASE_URL = "https://api.jeyshawnng.com";
const API_BASE   = `${BASE_URL}/api/careers`;
const UPLOAD_URL = `${BASE_URL}/api/upload`;
// const API_BASE   = `${BASE_URL}/api/careers`;
// const UPLOAD_URL = `${BASE_URL}/api/upload`;

const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BASE_URL}${url}`;
};

/* ─────────────────────────────────────────────
   LOCAL CACHE HELPERS (cache-first, DB-driven)
───────────────────────────────────────────── */
const CACHE_KEY = "jeyshawn_careers_data";

const getCachedData = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const setCachedData = (data) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch {
    // storage full/unavailable — fail silently, page still works
  }
};

/* ─────────────────────────────────────────────
   INLINE STYLES FOR THE APPLICATION FORM
───────────────────────────────────────────── */
const formStyles = `
  .appform__overlay { position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:1000;display:flex;justify-content:center;align-items:flex-start;overflow-y:auto;padding:32px 16px 48px; }
  .appform__modal { background:#fff;width:100%;max-width:960px;border-radius:10px;padding:32px 28px 48px;font-family:'Times New Roman',Times,serif;position:relative; }
  .appform__page-header { display:flex;justify-content:space-between;align-items:center;margin-bottom:32px; }
  .appform__page-title { font-size:33px;font-weight:600;color:#1a1a1a;letter-spacing:.01em; }
  .appform__close-btn { width:28px;height:28px;border-radius:50%;border:1.5px solid #ccc;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#666;font-size:16px;flex-shrink:0; }
  .appform__close-btn:hover { border-color:#3db87a;color:#3db87a; }
  .appform__section { margin-bottom:36px; }
  .appform__section-header { display:flex;align-items:center;gap:14px;margin-bottom:6px; }
  .appform__section-title { font-size:20px;font-weight:600;color:#1a1a1a;white-space:nowrap; }
  .appform__section-line { flex:1;height:1.5px;background:#3db87a;border-radius:2px; }
  .appform__section-sublabel { font-size:11px;color:#999;font-weight:300;margin-bottom:18px;font-style:italic; }
  .appform__row { display:grid;grid-template-columns:1fr 1fr;gap:20px 28px;margin-bottom:20px; }
  .appform__row--single { grid-template-columns:1fr; }
  .appform__row--single .appform__group { max-width:300px; }
  .appform__group { display:flex;flex-direction:column;gap:5px; }
  .appform__group--full { grid-column:1/-1;max-width:100%!important; }
  .appform__label { font-size:16px;font-weight:400;color:#666; }
  .appform__input { border:none;border-bottom:1.5px solid #d4d4d4;background:transparent;font-family:'Times New Roman',Times,serif;font-size:18px;color:#1a1a1a;padding:5px 0;outline:none;width:100%; }
  .appform__input:focus { border-bottom-color:#3db87a; }
  .appform__textarea { border:none;border-bottom:1.5px solid #d4d4d4;background:transparent;font-family:'Times New Roman',Times,serif;font-size:18px;color:#1a1a1a;padding:5px 0;outline:none;width:100%;resize:none;min-height:52px; }
  .appform__textarea:focus { border-bottom-color:#3db87a; }
  .appform__select-wrap { position:relative; }
  .appform__select { appearance:none;-webkit-appearance:none;border:none;border-bottom:1.5px solid #d4d4d4;background:transparent;font-family:'Times New Roman',Times,serif;font-size:18px;color:#1a1a1a;padding:5px 24px 5px 0;outline:none;cursor:pointer;width:100%; }
  .appform__select:focus { border-bottom-color:#3db87a; }
  .appform__select-arrow { position:absolute;right:3px;top:50%;transform:translateY(-50%);pointer-events:none;color:#999;display:flex; }
  .appform__checkbox-label { font-size:11.5px;color:#999;font-weight:300;margin-bottom:10px;font-style:italic; }
  .appform__checkbox-group { display:flex;align-items:center;gap:24px;flex-wrap:wrap; }
  .appform__checkbox-item { display:flex;align-items:center;gap:6px;cursor:pointer; }
  .appform__checkbox-item input[type="checkbox"] { appearance:none;-webkit-appearance:none;width:13px;height:13px;border:1.5px solid #bbb;border-radius:2px;cursor:pointer;position:relative;flex-shrink:0; }
  .appform__checkbox-item input[type="checkbox"]:checked { background:#3db87a;border-color:#3db87a; }
  .appform__checkbox-item input[type="checkbox"]:checked::after { content:'';position:absolute;left:2px;top:-1px;width:5px;height:8px;border:2px solid #fff;border-top:none;border-left:none;transform:rotate(45deg); }
  .appform__checkbox-item span { font-size:12px;color:#444;user-select:none; }
  .appform__upload-label { font-size:13.5px;color:#666;margin-bottom:8px;display:block; }
  .appform__upload-box { border:1.5px dashed #d0d0d0;border-radius:6px;padding:28px 16px;text-align:center;margin-bottom:18px;background:#fafafa; }
  .appform__upload-box:hover { border-color:#3db87a;background:#f7fbf9; }
  .appform__upload-hint { font-size:12px;color:#aaa;margin-bottom:12px; }
  .appform__upload-success { font-size:13px;color:#3db87a;font-weight:500;margin-bottom:10px;display:flex;align-items:center;justify-content:center;gap:6px; }
  .appform__upload-btn { background:#3db87a;color:#fff;border:none;border-radius:4px;padding:7px 20px;font-family:'Times New Roman',Times,serif;font-size:14px;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:6px; }
  .appform__upload-btn:hover { background:#32a46a; }
  .appform__charcount { font-size:10.5px;color:#3db87a;text-align:right;margin-top:4px; }
  .appform__submit-wrap { display:flex;justify-content:flex-end;margin-top:12px; }
  .appform__submit-btn { background:#3db87a;color:#fff;border:none;border-radius:6px;padding:11px 36px;font-family:'Times New Roman',Times,serif;font-size:13.5px;font-weight:500;cursor:pointer; }
  .appform__submit-btn:hover { background:#32a46a; }
  .appform__submit-btn:disabled { background:#a0d9bc;cursor:not-allowed; }
  .appform__error { color:#e53935;font-size:13px;text-align:center;margin-top:12px; }
  .appform__success { color:#3db87a;font-size:13px;text-align:center;margin-top:12px;font-weight:500; }
`;

/* ─────────────────────────────────────────────
   SMALL HELPERS
───────────────────────────────────────────── */
const ChevronDown = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 6 8 10 12 6" />
  </svg>
);
const UploadIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);
const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const SectionHeader = ({ title }) => (
  <div className="appform__section-header">
    <span className="appform__section-title">{title}</span>
    <div className="appform__section-line" />
  </div>
);

/* ─────────────────────────────────────────────
   DYNAMIC FIELD RENDERER (used by ApplicationForm)
───────────────────────────────────────────── */
function DynamicField({ field, value, onChange, fileState, onFileChange }) {
  const { type, label, key: fkey, required, fullWidth, options, maxChars, accept, hint } = field;

  const inputId = `field-${field.id}`;

  if (type === "file") {
    const file = fileState?.[fkey] || null;
    return (
      <div>
        <span className="appform__upload-label">{label}{required ? " – Mandatory" : ""}</span>
        <div className="appform__upload-box">
          {file ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "center" }}>
              <p className="appform__upload-success"><CheckIcon /> {file.name}</p>
              <button type="button" className="appform__upload-btn" onClick={() => document.getElementById(inputId)?.click()}>
                <UploadIcon /> Change File
              </button>
            </div>
          ) : (
            <>
              <p className="appform__upload-hint">{hint}</p>
              <button type="button" className="appform__upload-btn" onClick={() => document.getElementById(inputId)?.click()}>
                <UploadIcon /> Import
              </button>
            </>
          )}
        </div>
        <input type="file" id={inputId} accept={accept} style={{ display: "none" }}
          onChange={e => { const f = e.target.files[0]; if (f) onFileChange(fkey, f); }} />
      </div>
    );
  }

  if (type === "checkbox") {
    return (
      <div style={{ marginBottom: 8 }}>
        <span className="appform__checkbox-label">{label}</span>
        <div className="appform__checkbox-group">
          {(options || []).map(opt => (
            <label className="appform__checkbox-item" key={opt}>
              <input type="checkbox" checked={value === opt} onChange={() => onChange(fkey, opt)} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
      </div>
    );
  }

  if (type === "select") {
    return (
      <div className="appform__group">
        <label className="appform__label">{label}</label>
        <div className="appform__select-wrap">
          <select className="appform__select" value={value || ""} onChange={e => onChange(fkey, e.target.value)}>
            <option value="" />
            {(options || []).map(o => <option key={o}>{o}</option>)}
          </select>
          <span className="appform__select-arrow"><ChevronDown /></span>
        </div>
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className={`appform__group${fullWidth ? " appform__group--full" : ""}`}>
        <label className="appform__label">{label}</label>
        <textarea className="appform__textarea" rows={4} maxLength={maxChars}
          value={value || ""} onChange={e => onChange(fkey, e.target.value)} />
        {maxChars && <div className="appform__charcount">{(value || "").length}/{maxChars}</div>}
      </div>
    );
  }

  // text / email / number / date
  return (
    <div className={`appform__group${fullWidth ? " appform__group--full" : ""}`}>
      <label className="appform__label">{label}{!required && " (Optional)"}</label>
      <input className="appform__input" type={type} required={required}
        value={value || ""} onChange={e => onChange(fkey, e.target.value)} />
    </div>
  );
}

/* ─────────────────────────────────────────────
   APPLICATION FORM (driven by formSections data)
───────────────────────────────────────────── */
const ApplicationForm = ({ onClose, formSections }) => {
  const [fieldValues, setFieldValues] = useState({});
  const [fileValues,  setFileValues]  = useState({});
  const [submitting,  setSubmitting]  = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange    = (key, val) => setFieldValues(prev => ({ ...prev, [key]: val }));
  const handleFileChange = (key, file) => setFileValues(prev => ({ ...prev, [key]: file }));

  const handleOverlayClick = (e) => { if (e.target === e.currentTarget) onClose(); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);
    try {
      const formData = new FormData();
      Object.entries(fieldValues).forEach(([k, v]) => formData.append(k, v));
      Object.entries(fileValues).forEach(([k, f]) => f && formData.append(k, f));
      await axios.post(`${BASE_URL}/api/applications`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSubmitSuccess(true);
      setTimeout(() => onClose(), 5000);
    } catch (err) {
      console.error("Failed to submit application:", err);
      setSubmitError("Failed to submit application. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <style>{formStyles}</style>
      <div className="appform__overlay" onClick={handleOverlayClick}>
        <div className="appform__modal">
          <div className="appform__page-header">
            <span className="appform__page-title">Application Form</span>
            <button type="button" className="appform__close-btn" onClick={onClose}>✕</button>
          </div>
          <form onSubmit={handleSubmit}>
            {formSections.map(section => {
              const fileFields  = section.fields.filter(f => f.type === "file");
              const otherFields = section.fields.filter(f => f.type !== "file");

              // Pair non-file fields into rows of 2 (respecting fullWidth)
              const rows = [];
              let i = 0;
              while (i < otherFields.length) {
                const f = otherFields[i];
                if (f.fullWidth || f.type === "checkbox" || f.type === "textarea") {
                  rows.push([f]);
                  i++;
                } else {
                  const next = otherFields[i + 1];
                  if (next && !next.fullWidth && next.type !== "checkbox" && next.type !== "textarea") {
                    rows.push([f, next]);
                    i += 2;
                  } else {
                    rows.push([f]);
                    i++;
                  }
                }
              }

              return (
                <div className="appform__section" key={section.id}>
                  <SectionHeader title={section.title} />
                  {section.sublabel && <p className="appform__section-sublabel">{section.sublabel}</p>}

                  {rows.map((row, ri) => (
                    <div key={ri} className={`appform__row${row.length === 1 && (row[0].fullWidth || row[0].type === "checkbox" || row[0].type === "textarea") ? " appform__row--single" : ""}`}>
                      {row.map(field => (
                        <DynamicField key={field.id} field={field}
                          value={fieldValues[field.key]}
                          onChange={handleChange}
                          fileState={fileValues}
                          onFileChange={handleFileChange}
                        />
                      ))}
                    </div>
                  ))}

                  {fileFields.map(field => (
                    <DynamicField key={field.id} field={field}
                      value={fieldValues[field.key]}
                      onChange={handleChange}
                      fileState={fileValues}
                      onFileChange={handleFileChange}
                    />
                  ))}
                </div>
              );
            })}

            {submitError   && <p className="appform__error">{submitError}</p>}
            {submitSuccess && <p className="appform__success">Application submitted successfully! Closing...</p>}
            <div className="appform__submit-wrap">
              <button type="submit" className="appform__submit-btn" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit Application"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

/* ─────────────────────────────────────────────
   IMAGE UPLOAD FIELD (for CMS editor)
───────────────────────────────────────────── */
function ImageUploadField({ label, currentUrl, onUploaded }) {
  const [preview,   setPreview]   = useState(resolveUrl(currentUrl) || null);
  const [uploading, setUploading] = useState(false);
  const [error,     setError]     = useState(null);
  const inputRef = useRef();

  useEffect(() => { setPreview(resolveUrl(currentUrl) || null); }, [currentUrl]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    setError(null);
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("image", file);
      const res  = await fetch(UPLOAD_URL, { method: "POST", body: fd });
      const json = await res.json();
      if (!json.success) throw new Error(json.message || "Upload failed");
      onUploaded(json.url);
      setPreview(resolveUrl(json.url));
    } catch {
      setError("Upload failed. Try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    onUploaded("");
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="editor-img-field">
      <label>{label}</label>
      {preview ? (
        <div className="editor-img-preview-wrap">
          <img src={preview} alt="preview" className="editor-img-preview" />
          {uploading
            ? <div className="editor-img-uploading"><div className="editor-loading__spinner editor-loading__spinner--sm" /><span>Uploading...</span></div>
            : <div className="editor-img-actions">
                <button type="button" className="editor-img-btn editor-img-btn--change" onClick={() => inputRef.current?.click()}>Change</button>
                <button type="button" className="editor-img-btn editor-img-btn--remove" onClick={handleRemove}>Remove</button>
              </div>
          }
        </div>
      ) : (
        <button type="button" className="editor-img-dropzone" onClick={() => inputRef.current?.click()} disabled={uploading}>
          {uploading
            ? <><div className="editor-loading__spinner editor-loading__spinner--sm" /><span>Uploading...</span></>
            : <><span className="editor-img-dropzone__icon">🖼️</span><span>Click to upload image</span><span className="editor-img-dropzone__hint">JPG, PNG, WEBP — max 10 MB</span></>
          }
        </button>
      )}
      {error && <p className="editor-img-error">{error}</p>}
      <input ref={inputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
    </div>
  );
}

/* ─────────────────────────────────────────────
   CMS EDIT MODAL
───────────────────────────────────────────── */
const FIELD_TYPES = ["text","email","number","date","textarea","select","checkbox","file"];

function CareersEditModal({ data, onSave, onClose, saving }) {
  const [draft, setDraft] = useState(() => JSON.parse(JSON.stringify(data)));

  const uid = () => `id_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;

  // ── Page content helpers ──
  const setTitle      = v  => setDraft(d => ({ ...d, title: v }));
  const setBtnLabel   = v  => setDraft(d => ({ ...d, applyButtonLabel: v }));
  const addParagraph  = () => setDraft(d => ({ ...d, paragraphs: [...d.paragraphs, { id: uid(), label: "", bold: false, text: "" }] }));
  const removeParagraph = i => setDraft(d => ({ ...d, paragraphs: d.paragraphs.filter((_, idx) => idx !== i) }));
  const setParagraphField = (i, field, val) => setDraft(d => {
    const p = [...d.paragraphs]; p[i] = { ...p[i], [field]: val }; return { ...d, paragraphs: p };
  });
  const addBullet    = () => setDraft(d => ({ ...d, bullets: [...d.bullets, ""] }));
  const removeBullet = i  => setDraft(d => ({ ...d, bullets: d.bullets.filter((_, idx) => idx !== i) }));
  const setBullet    = (i, v) => setDraft(d => { const b = [...d.bullets]; b[i] = v; return { ...d, bullets: b }; });

  // ── Form section helpers ──
  const addSection    = () => setDraft(d => ({ ...d, formSections: [...d.formSections, { id: uid(), title: "New Section", sublabel: "", fields: [] }] }));
  const removeSection = si => setDraft(d => ({ ...d, formSections: d.formSections.filter((_, i) => i !== si) }));
  const setSectionField = (si, field, val) => setDraft(d => {
    const s = [...d.formSections]; s[si] = { ...s[si], [field]: val }; return { ...d, formSections: s };
  });

  // ── Field helpers ──
  const addField = (si) => setDraft(d => {
    const s = [...d.formSections];
    s[si] = { ...s[si], fields: [...s[si].fields, { id: uid(), type: "text", label: "New Field", key: `field_${uid()}`, required: false, fullWidth: false }] };
    return { ...d, formSections: s };
  });
  const removeField = (si, fi) => setDraft(d => {
    const s = [...d.formSections];
    s[si] = { ...s[si], fields: s[si].fields.filter((_, i) => i !== fi) };
    return { ...d, formSections: s };
  });
  const setFieldProp = (si, fi, prop, val) => setDraft(d => {
    const s = [...d.formSections];
    const fields = [...s[si].fields];
    fields[fi] = { ...fields[fi], [prop]: val };
    s[si] = { ...s[si], fields };
    return { ...d, formSections: s };
  });
  const addOption = (si, fi) => setDraft(d => {
    const s = [...d.formSections];
    const fields = [...s[si].fields];
    fields[fi] = { ...fields[fi], options: [...(fields[fi].options || []), "New Option"] };
    s[si] = { ...s[si], fields };
    return { ...d, formSections: s };
  });
  const removeOption = (si, fi, oi) => setDraft(d => {
    const s = [...d.formSections];
    const fields = [...s[si].fields];
    fields[fi] = { ...fields[fi], options: fields[fi].options.filter((_, i) => i !== oi) };
    s[si] = { ...s[si], fields };
    return { ...d, formSections: s };
  });
  const setOption = (si, fi, oi, val) => setDraft(d => {
    const s = [...d.formSections];
    const fields = [...s[si].fields];
    const opts = [...(fields[fi].options || [])]; opts[oi] = val;
    fields[fi] = { ...fields[fi], options: opts };
    s[si] = { ...s[si], fields };
    return { ...d, formSections: s };
  });

  const editorStyle = {
    overlay:    { position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:2000,display:"flex",justifyContent:"center",alignItems:"flex-start",overflowY:"auto",padding:"24px 16px 48px" },
    modal:      { background:"#fff",width:"100%",maxWidth:800,borderRadius:10,overflow:"hidden",display:"flex",flexDirection:"column",maxHeight:"90vh" },
    header:     { padding:"20px 24px",borderBottom:"1px solid #e5e7eb",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0 },
    body:       { padding:"24px",overflowY:"auto",flex:1 },
    footer:     { padding:"16px 24px",borderTop:"1px solid #e5e7eb",display:"flex",justifyContent:"flex-end",gap:10,flexShrink:0 },
    sectionTitle:{ fontSize:13,fontWeight:700,color:"#374151",textTransform:"uppercase",letterSpacing:".05em",marginBottom:12,marginTop:20 },
    group:      { background:"#f9fafb",border:"1px solid #e5e7eb",borderRadius:8,padding:"14px 16px",marginBottom:12 },
    fieldCard:  { background:"#fff",border:"1px solid #e5e7eb",borderRadius:6,padding:"12px 14px",marginBottom:10 },
    label:      { display:"block",fontSize:12,fontWeight:600,color:"#6b7280",marginBottom:4 },
    input:      { width:"100%",border:"1px solid #d1d5db",borderRadius:6,padding:"7px 10px",fontSize:13,outline:"none",boxSizing:"border-box" },
    row:        { display:"flex",gap:8,alignItems:"center",marginBottom:6 },
    removeBtn:  { background:"#fee2e2",border:"none",borderRadius:4,color:"#dc2626",cursor:"pointer",padding:"3px 8px",fontSize:12,fontWeight:600,flexShrink:0 },
    addBtn:     { background:"#f3f4f6",border:"1px dashed #9ca3af",borderRadius:6,padding:"7px 14px",fontSize:12,color:"#6b7280",cursor:"pointer",width:"100%",marginTop:6 },
  };

  return (
    <div style={editorStyle.overlay} onClick={onClose}>
      <div style={editorStyle.modal} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={editorStyle.header}>
          <h2 style={{ margin:0,fontSize:18,fontWeight:700 }}>Edit — Careers Page</h2>
          <button onClick={onClose} style={{ background:"none",border:"none",fontSize:20,cursor:"pointer",color:"#6b7280" }}>✕</button>
        </div>

        <div style={editorStyle.body}>

          {/* BANNER IMAGE */}
          <p style={editorStyle.sectionTitle}>Banner Image</p>
          <ImageUploadField label="Banner Image (top of page)" currentUrl={draft.bannerImage}
            onUploaded={url => setDraft(d => ({ ...d, bannerImage: url }))} />

          {/* PAGE TITLE */}
          <p style={editorStyle.sectionTitle}>Page Title</p>
          <div style={editorStyle.group}>
            <label style={editorStyle.label}>Heading</label>
            <textarea style={{ ...editorStyle.input, resize:"vertical", minHeight:60 }} value={draft.title} onChange={e => setTitle(e.target.value)} rows={3} />
          </div>

          {/* APPLY BUTTON */}
          <p style={editorStyle.sectionTitle}>Apply Button</p>
          <div style={editorStyle.group}>
            <label style={editorStyle.label}>Button Label</label>
            <input style={editorStyle.input} value={draft.applyButtonLabel} onChange={e => setBtnLabel(e.target.value)} />
          </div>

          {/* PARAGRAPHS */}
          <p style={editorStyle.sectionTitle}>Content Paragraphs</p>
          {draft.paragraphs.map((para, i) => (
            <div style={editorStyle.group} key={para.id}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8 }}>
                <span style={{ fontSize:12,fontWeight:600,color:"#6b7280" }}>Paragraph {i + 1}</span>
                <button style={editorStyle.removeBtn} onClick={() => removeParagraph(i)}>✕ Remove</button>
              </div>
              <label style={editorStyle.label}>Label / Bold heading (leave empty if none)</label>
              <input style={{ ...editorStyle.input, marginBottom:8 }} value={para.label} onChange={e => setParagraphField(i, "label", e.target.value)} />
              <label style={editorStyle.label}>Text (leave empty if this is only a heading)</label>
              <textarea style={{ ...editorStyle.input, resize:"vertical", minHeight:50 }} value={para.text} onChange={e => setParagraphField(i, "text", e.target.value)} rows={3} />
              <label style={{ ...editorStyle.label, marginTop:8, display:"flex", alignItems:"center", gap:6, cursor:"pointer" }}>
                <input type="checkbox" checked={para.bold} onChange={e => setParagraphField(i, "bold", e.target.checked)} />
                Bold label
              </label>
            </div>
          ))}
          <button style={editorStyle.addBtn} onClick={addParagraph}>+ Add Paragraph</button>

          {/* BULLET LIST */}
          <p style={editorStyle.sectionTitle}>Bullet List</p>
          {draft.bullets.map((b, i) => (
            <div style={editorStyle.row} key={i}>
              <input style={{ ...editorStyle.input, flex:1 }} value={b} onChange={e => setBullet(i, e.target.value)} />
              <button style={editorStyle.removeBtn} onClick={() => removeBullet(i)}>✕</button>
            </div>
          ))}
          <button style={editorStyle.addBtn} onClick={addBullet}>+ Add Bullet</button>

          {/* FORM SECTIONS */}
          <p style={{ ...editorStyle.sectionTitle, marginTop:28 }}>Application Form Sections</p>
          {draft.formSections.map((sec, si) => (
            <div style={{ ...editorStyle.group, border:"1px solid #d1d5db" }} key={sec.id}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10 }}>
                <span style={{ fontSize:13,fontWeight:700,color:"#111827" }}>Section {si + 1}</span>
                <button style={editorStyle.removeBtn} onClick={() => removeSection(si)}>✕ Remove Section</button>
              </div>

              <label style={editorStyle.label}>Section Title</label>
              <input style={{ ...editorStyle.input, marginBottom:8 }} value={sec.title}
                onChange={e => setSectionField(si, "title", e.target.value)} />

              <label style={editorStyle.label}>Sublabel (optional italic note under title)</label>
              <input style={{ ...editorStyle.input, marginBottom:12 }} value={sec.sublabel || ""}
                onChange={e => setSectionField(si, "sublabel", e.target.value)} />

              <p style={{ fontSize:12,fontWeight:700,color:"#374151",marginBottom:8 }}>Fields</p>
              {sec.fields.map((field, fi) => (
                <div style={editorStyle.fieldCard} key={field.id}>
                  <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8 }}>
                    <span style={{ fontSize:11,color:"#9ca3af",fontWeight:600 }}>Field {fi + 1} — {field.type}</span>
                    <button style={editorStyle.removeBtn} onClick={() => removeField(si, fi)}>✕</button>
                  </div>

                  <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8 }}>
                    <div>
                      <label style={editorStyle.label}>Label</label>
                      <input style={editorStyle.input} value={field.label}
                        onChange={e => setFieldProp(si, fi, "label", e.target.value)} />
                    </div>
                    <div>
                      <label style={editorStyle.label}>Field Key (unique, no spaces)</label>
                      <input style={editorStyle.input} value={field.key}
                        onChange={e => setFieldProp(si, fi, "key", e.target.value.replace(/\s/g,"_"))} />
                    </div>
                  </div>

                  <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:8 }}>
                    <div>
                      <label style={editorStyle.label}>Type</label>
                      <select style={{ ...editorStyle.input }} value={field.type}
                        onChange={e => setFieldProp(si, fi, "type", e.target.value)}>
                        {FIELD_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div style={{ display:"flex",alignItems:"center",gap:6,paddingTop:18 }}>
                      <input type="checkbox" id={`req-${field.id}`} checked={field.required || false}
                        onChange={e => setFieldProp(si, fi, "required", e.target.checked)} />
                      <label htmlFor={`req-${field.id}`} style={{ fontSize:12,color:"#374151",cursor:"pointer" }}>Required</label>
                    </div>
                    <div style={{ display:"flex",alignItems:"center",gap:6,paddingTop:18 }}>
                      <input type="checkbox" id={`fw-${field.id}`} checked={field.fullWidth || false}
                        onChange={e => setFieldProp(si, fi, "fullWidth", e.target.checked)} />
                      <label htmlFor={`fw-${field.id}`} style={{ fontSize:12,color:"#374151",cursor:"pointer" }}>Full width</label>
                    </div>
                  </div>

                  {/* Options — for select / checkbox */}
                  {(field.type === "select" || field.type === "checkbox") && (
                    <div style={{ marginTop:8 }}>
                      <label style={editorStyle.label}>Options</label>
                      {(field.options || []).map((opt, oi) => (
                        <div style={editorStyle.row} key={oi}>
                          <input style={{ ...editorStyle.input, flex:1 }} value={opt}
                            onChange={e => setOption(si, fi, oi, e.target.value)} />
                          <button style={editorStyle.removeBtn} onClick={() => removeOption(si, fi, oi)}>✕</button>
                        </div>
                      ))}
                      <button style={{ ...editorStyle.addBtn, marginTop:4 }} onClick={() => addOption(si, fi)}>+ Add Option</button>
                    </div>
                  )}

                  {/* File accept + hint */}
                  {field.type === "file" && (
                    <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8 }}>
                      <div>
                        <label style={editorStyle.label}>Accept (e.g. .pdf,.doc)</label>
                        <input style={editorStyle.input} value={field.accept || ""}
                          onChange={e => setFieldProp(si, fi, "accept", e.target.value)} />
                      </div>
                      <div>
                        <label style={editorStyle.label}>Hint text</label>
                        <input style={editorStyle.input} value={field.hint || ""}
                          onChange={e => setFieldProp(si, fi, "hint", e.target.value)} />
                      </div>
                    </div>
                  )}
                </div>
              ))}
              <button style={editorStyle.addBtn} onClick={() => addField(si)}>+ Add Field</button>
            </div>
          ))}
          <button style={{ ...editorStyle.addBtn, marginTop:8 }} onClick={addSection}>+ Add Section</button>

        </div>

        {/* Footer */}
        <div style={editorStyle.footer}>
          <button className="btn btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn btn--orange" onClick={() => onSave(draft)} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   MAIN PAGE
   Data comes only from the DB. On first ever
   visit (no cache) it loads from the API. On
   return visits it renders instantly from
   localStorage, then silently re-checks the DB
   in the background (and on an interval) and
   only updates the UI + cache if the DB data
   has actually changed.
───────────────────────────────────────────── */
const CareersPage = () => {
  const [pageData,    setPageData]    = useState(() => getCachedData());
  const [loading,     setLoading]     = useState(() => !getCachedData());
  const [fetchErr,    setFetchErr]    = useState(null);
  const [modalOpen,   setModalOpen]   = useState(false);
  const [saving,      setSaving]      = useState(false);
  const [saveMsg,     setSaveMsg]     = useState(null);
  const [isFormOpen,  setIsFormOpen]  = useState(false);

  const fetchData = async (isBackground = false) => {
    try {
      if (!isBackground) {
        setLoading(true);
        setFetchErr(null);
      }

      const res  = await fetch(`${API_BASE}`);
      const json = await res.json();

      if (json.success && json.data) {
        const cached = getCachedData();
        const changed = JSON.stringify(cached) !== JSON.stringify(json.data);
        if (changed) {
          setPageData(json.data);
          setCachedData(json.data);
        }
      } else if (!isBackground && !getCachedData()) {
        setPageData(null);
        setFetchErr("No data found.");
      }
    } catch {
      // Background syncs, or foreground loads when we already have cached
      // data, fail silently so the page keeps showing what it has.
      if (!isBackground && !getCachedData()) {
        setPageData(null);
        setFetchErr("Could not load page data.");
      }
    } finally {
      if (!isBackground) setLoading(false);
    }
  };

  useEffect(() => {
    const hasCache = !!getCachedData();
    fetchData(hasCache); // silent sync if we already have cached data to show

    const interval = setInterval(() => fetchData(true), 30000); // auto-check DB every 30s
    return () => clearInterval(interval);
  }, []);

  const handleSave = async (draft) => {
    try {
      setSaving(true);
      const res  = await fetch(API_BASE, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(draft),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message || "Save failed");
      setPageData(json.data);
      setCachedData(json.data);
      setModalOpen(false);
      showToast("Changes saved successfully!");
    } catch {
      showToast("Save failed. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const showToast = (msg) => { setSaveMsg(msg); setTimeout(() => setSaveMsg(null), 3500); };

  const bannerImg = resolveUrl(pageData?.bannerImage);

  return (
    <>
      <button
        title="Edit page"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: 70, right: 20, zIndex: 10, background: "rgba(255,255,255,0.9)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
      >
        <CiEdit size={24} color="#333" />
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={() => fetchData(false)}>Retry</button></div>}

      {modalOpen && pageData && (
        <CareersEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} />
      )}

      {pageData && (
        <>
          <div className="img_carrierscar">
            {bannerImg && <img src={bannerImg} alt="img" />}
          </div>

          <div className="careers-container">
            <div className="careers-content">
              <div className="title-section">
                <h1 className="careers-title">{pageData.title}</h1>
                <div className="orange-underline"></div>
              </div>

              {pageData.paragraphs?.map((para, i) => (
                <React.Fragment key={para.id || i}>
                  {para.label && <p className={`intro-text${para.bold ? " mkbold" : ""}`}>{para.label}</p>}
                  {para.text  && <p className="intro-text">{para.text}</p>}
                </React.Fragment>
              ))}

              {pageData.bullets?.length > 0 && (
                <ul className="catext">
                  {pageData.bullets.map((b, i) => <li key={i}>{b}</li>)}
                </ul>
              )}

              <button className="btn btn--orange" onClick={() => setIsFormOpen(true)}>
                {pageData.applyButtonLabel || "Apply Now"}
              </button>
            </div>

            {isFormOpen && (
              <ApplicationForm onClose={() => setIsFormOpen(false)} formSections={pageData.formSections || []} />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default CareersPage;